import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { GenericSkeletonComponent, PegaMijnModule, provideAppCore } from '@ap/pega';

import { BaseStarterAppModule } from '../base-starter-app/base-starter-app.module';

import { StarterAppMijnComponent } from './starter-app-mijn.component';

@NgModule({
    imports: [
        BaseStarterAppModule,
        GenericSkeletonComponent,
        PegaMijnModule,
        RouterModule.forRoot([], {
            useHash: false,
            enableTracing: false
        })
    ],
    providers: [...provideAppCore({ standalone: true })],
    declarations: [StarterAppMijnComponent],
    exports: [BaseStarterAppModule, PegaMijnModule, StarterAppMijnComponent]
})
export class StarterAppMijnModule {}
